export function dasherize(string?: string) {
  if (!string) return '';
  return string.replace(/\./gi, '').replace(/\s+/g, '-').toLowerCase();
}
